import React from "react";
import { Center } from "native-base";
import { Image, StyleProp, ViewStyle } from "react-native";
// import { translate } from "../locales/translate";
import Theme from "../argon-ui/Theme";
import Text from "./TextFont";

interface PropsType {
  size?: number;
  style?: any;
  messageLoading?: string;
  containerStyle?: StyleProp<ViewStyle> | undefined;
}
const Spinner = (props: PropsType) => {
  const { size = 20, style, messageLoading, containerStyle } = props;
  return (
    <Center w="100%" h="100%" style={containerStyle || {}}>
      <Image
        // width={size}
        // height={size}
        style={{
          width: size,
          height: size,
          ...style,
        }}
        source={require("../../assets/images/spinner.gif")}
      />
      {messageLoading && (
        <Text
          style={{ fontSize: 12, marginTop: 10, color: Theme.COLORS.GRAY_DARK }}
        >
          {messageLoading}
        </Text>
      )}
    </Center>
  );
};

export default Spinner;
